export const StorageKeys = {
    LatestLaunchId: 'da-latest-launch-id',
    PreviousPath:'da-previous-path',
    CurrentPath:'da-current-path'
};
